import React from 'react';
import { Box, Chip, alpha } from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ReplayIcon from '@mui/icons-material/Replay';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { orange, green } from '@mui/material/colors';
import { IconWithText } from './components'; // Adjust import path
import { Workflow } from '../../../enums/orders';
import { chipOpacity, chipPadding } from './common';

export const showWorkflow = (
  workflow: Workflow,
  is_exchange: boolean,
  exchange_for: number | undefined,
  return_reason: string
): JSX.Element => {
  const isReturn = workflow === Workflow.RETURN;
  const icon = isReturn ? <ReplayIcon /> : <LocalShippingIcon />;
  const backgroundColor = isReturn
    ? alpha(orange[400], chipOpacity)
    : alpha(green[400], chipOpacity);

  const label = (
    <IconWithText>
        {workflow}
        {is_exchange && <SyncAltIcon fontSize="small" style={{ marginLeft: 4 }} />}
    </IconWithText>
  );

  return <Box display={"flex"} width={"auto"} flexDirection={"column"} alignContent={"center"}>
            <Chip
              label={label}
              icon={icon}
              variant="filled"
              size="small"
              style={{
                  padding: chipPadding,
                  backgroundColor,
              }}
            />

            {exchange_for && <span style={{fontSize: '0.9em', fontWeight: 400, color: '#555' }}>
                            ↳ Exchange for{' '}
                <a
                    href={`/order/${exchange_for}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline', color: '#1976d2' }}
                >
                    #1{exchange_for}
                </a>
            </span>}

            {return_reason && !exchange_for && <span style={{fontSize: '0.9em', fontWeight: 400, color: '#555' }}>
                            ↳ {return_reason}
            </span>}


            


</Box>
};
